export default class ThemeSwitcher {
    constructor($element) {
        this.$element = $element;

        this.switchTheme = this.switchTheme.bind(this);

        this.$element.addEventListener('change', this.switchTheme)
    }

    switchTheme(e) {
        const body = document.querySelector('body');
        body.classList.remove('red');
        body.classList.remove('yellow');
        body.classList.remove('purple');
        body.classList.remove('pink');
        body.classList.remove('gold');
        body.classList.remove('christmas');
        body.classList.remove('valentine');
        body.classList.remove('easter');
        body.classList.add(this.$element.value);
    }
}